var moment = require('moment')
var dateutils = require('./dateutils')

const state = {
  all: [],
  headers: ['fileName', 'imported', 'error', 'importDate', 'finishImportDate', 'totalRows', 'totalInvoices', 'importedNewInvoices', 'importedUpdateInvoices', 'warns'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  disablePaginationComponent: true,
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false
}

const mutations = {
  setRowsPerPage: function (state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage
  },
  changePageNumber: function (state, newCurrentPage) {
    state.currentPage = newCurrentPage
    // console.log('CHanged state page number to: ' + state.currentPage)
  },
  updateTotalRows: function (state, newTotalRows) {
    state.totalRows = newTotalRows
    // console.log('Mutated totalRows to: ' + state.totalRows)
  },
  toggleShowLoadingAnimation: function (state, show) {
    state.showLoadingAnimation = show
  },
  toggleshowLoadingError: function (state, show) {
    state.showLoadingError = show
  },
  toggleShowNoResult: function (state, show) {
    state.showNoResult = show
  },
  setLoadingErrorMessage: function (state, message) {
    state.loadingErrorMessage = message
  }
}

const getters = {
  getAll: function (state, getters, rootState) {
    return state.all
  },
  getHeaders: function (state, getters, rootState) {
    let extraHeaders = []
    for (let i = 0; i < state.headers.length; i++) {
      let eachHeader = state.headers[i]
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      })
    }
    return extraHeaders
  }
}

const actions = {
  showAllInvoices (context, payload) {
    context.state.all = []
    // context.state.headers = []

    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)

    let importsCollectionName = 'imports'

    // count total rows
    let firstQuery = context.rootState.firestoreDB.collection(importsCollectionName)
    firstQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.docs.length)
    })

    if (context.state.currentPage === 1) {
      let docQuery = context.rootState.firestoreDB.collection(importsCollectionName)
        .orderBy(payload.orderBys, 'desc')
        .limit(context.state.rowsPerPage)
      docQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          // console.log(doc.id + '=>' + doc.data())
          let documentData = doc.data()
          let invoiceObject = {}
          for (let eachProp in documentData) {
            let propName = eachProp
            // console.log('eachProp: ' + eachProp)
            if (propName === 'importDate' && doc.data()[eachProp]) {
              let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
              invoiceObject[propName] = m.format('DD/MMM/YYYY')
            } else if (propName === 'finishImportDate' && doc.data()[eachProp]) {
              let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
            } else {
              invoiceObject[propName] = doc.data()[eachProp]
            }
            // invoiceObject[propName] = doc.data()[eachProp]
            // context.state.headers.push(propName)
          }
          context.state.all.push(invoiceObject)
        })
        context.commit('toggleShowLoadingAnimation', false)
        if (context.state.all.length === 0) {
          context.commit('toggleShowNoResult', true)
        }
      }).catch(function (err) {
        console.log('Error while fetching documents in imports collection: ' + err)
        context.commit('toggleShowLoadingAnimation', false)

        context.commit('toggleshowLoadingError', true)
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
      })
    } else {
      let lastRowShown
      if (context.state.currentPage === 2) {
        lastRowShown = context.state.rowsPerPage
      } else {
        lastRowShown = ((context.state.currentPage - 1) * context.state.rowsPerPage)
      }
      console.log('lastRowShown: ' + lastRowShown)
      let docQuery = context.rootState.firestoreDB.collection(importsCollectionName)
        .orderBy(payload.orderBys, 'desc')
      docQuery.get().then(function (querySnapshot) {
        let lastVisibleSnapshot = querySnapshot.docs[lastRowShown]

        let docSubQuery = context.rootState.firestoreDB.collection(importsCollectionName)
          .orderBy(payload.orderBys)
          .startAt(lastVisibleSnapshot)
          .limit(context.state.rowsPerPage)
        docSubQuery.get().then(function (subQuerySnapshot) {
          subQuerySnapshot.forEach(function (subDoc) {
            // console.log(subDoc.id + '=>' + subDoc.data())
            let documentData = subDoc.data()
            let invoiceObject = {}
            for (let eachProp in documentData) {
              let propName = eachProp
              // console.log('eachProp: ' + eachProp)
              if (propName === 'importDate' && subDoc.data()[eachProp]) {
                let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
                invoiceObject[propName] = m.format('DD/MMM/YYYY')
              } else if (propName === 'finishImportDate' && subDoc.data()[eachProp]) {
                let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
              } else {
                invoiceObject[propName] = subDoc.data()[eachProp]
              }
              // invoiceObject[propName] = subDoc.data()[eachProp]
              // context.state.headers.push(propName)
            }
            context.state.all.push(invoiceObject)
          })
          context.commit('toggleShowLoadingAnimation', false)
          if (context.state.all.length === 0) {
            context.commit('toggleShowNoResult', true)
          }
        })
      }).catch(function (err) {
        console.log('Error while fetching documents in imports collection: ' + err)
        context.commit('toggleShowLoadingAnimation', false)

        context.commit('toggleshowLoadingError', true)
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
      })
    }
  }
}

export default { namespaced: true, state, mutations, actions, getters }



// WEBPACK FOOTER //
// ./src/store/invoiceimportsstoremodule.js